import { useNavigate } from 'react-router-dom';

import { IContent } from '@_entities/content';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { InformationPopup } from '@_shared/ui/Popup';

import { useContentAction } from '../hooks';

interface Props {
	content: IContent;
	isContentListPage: boolean;
}

export function ContentDeletePopup({ content, isContentListPage }: Props) {
	const navigate = useNavigate();
	const { popLayer } = useUILayerStore();
	const { dispatch } = useContentAction(content);

	return (
		<InformationPopup.Container closePopup={popLayer}>
			<InformationPopup.TextContainer>
				<InformationPopup.Title>콘텐츠를 삭제하시겠어요?</InformationPopup.Title>
				<InformationPopup.Warning>삭제하면 다시 복구할 수 없어요.</InformationPopup.Warning>
			</InformationPopup.TextContainer>
			<InformationPopup.ButtonContainer>
				<InformationPopup.Button type="deny" onClick={popLayer}>
					아니요
				</InformationPopup.Button>
				<InformationPopup.Button
					type="confirm"
					onClick={() => {
						dispatch({ type: 'DELETE_CONTENT' });
						// setTimeout(() => {
						popLayer();
						popLayer();
						if (!isContentListPage) {
							navigate(-1);
						}
						// }, 1000);
					}}
				>
					네, 삭제할게요
				</InformationPopup.Button>
			</InformationPopup.ButtonContainer>
		</InformationPopup.Container>
	);
}
